export default Array.from({ length: 16 }, (_, current) => {
  const field = `switch_dip_${current + 1}`;
  return {
    field,
    label: field,
    width: "4%",
    isSortable: false,
    isCSV: true,
  };
});
